'use client';

import { useEffect } from 'react';
import useAchievementStore from '../../store/useAchievementStore';
import { useAchievements } from '../../hooks/useAchievements';
import { achievementEvents } from '@/shared/events';
import { useStatsStore } from '@/features/Progress';

/**
 * Component to make achievement store available globally for integration
 * This is a workaround to allow the stats store to trigger achievement checks
 */
const AchievementIntegration = () => {
  const achievementStore = useAchievementStore;
  useAchievements();

  useEffect(() => {
    const unsubscribe = achievementEvents.subscribe(event => {
      if (event.type === 'check') {
        useAchievementStore
          .getState()
          .checkAchievements(useStatsStore.getState());
      }
    });

    // Make achievement store available globally for cross-store communication
    if (typeof window !== 'undefined') {
      (
        window as Window & { __achievementStore?: typeof achievementStore }
      ).__achievementStore = achievementStore;
    }
    return () => {
      if (typeof window !== 'undefined') {
        delete (
          window as Window & { __achievementStore?: typeof achievementStore }
        ).__achievementStore;
      }
      unsubscribe();
    };
  }, [achievementStore]);

  return null; //This component doesn't render anything
};

export default AchievementIntegration;
